import {
  Field,
  FieldDescription,
  FieldGroup,
  FieldLabel,
  FieldLegend,
  FieldSeparator,
  FieldSet,
} from "@/client/components/shad/field";
import { withForm } from "../../form-context";
import { skopaPlatformFormOptions } from "../shared";
import { PositionFields } from "../../components/PositionFields";
import { Switch } from "@/client/components/shad/switch";
import { Button } from "@/client/components/shad/button";
import { Card, CardContent, CardFooter } from "@/client/components/shad/card";
import { IconPlus, IconX } from "@tabler/icons-react";
import { Separator } from "@/client/components/shad/separator";

export const siloStatusOptions = [
  { label: "Active", value: "ACTIVE" },
  { label: "Standby", value: "STANDBY" },
  { label: "Loading", value: "LOADING" },
  { label: "Reloading", value: "RELOADING" },
  { label: "Maintenance", value: "MAINTENANCE" },
  { label: "Damaged", value: "DAMAGED" },
  { label: "Offline", value: "OFFLINE" },
];

export const siloPlatformLocationOptions = [
  { label: "Bow", value: "BOW" },
  { label: "Stern", value: "STERN" },
  { label: "Port", value: "PORT" },
  { label: "Starboard", value: "STARBOARD" },
  { label: "Center", value: "CENTER" },
  { label: "Top", value: "TOP" },
  { label: "Bottom", value: "BOTTOM" },
  { label: "Left Wing", value: "LEFT_WING" },
  { label: "Right Wing", value: "RIGHT_WING" },
  { label: "Fuselage", value: "FUSELAGE" },
  { label: "Roof", value: "ROOF" },
  { label: "Front", value: "FRONT" },
  { label: "Rear", value: "REAR" },
  { label: "Custom", value: "CUSTOM" },
];

export const SilosBlock = withForm({
  ...skopaPlatformFormOptions,
  render: function Render({ form }) {
    return (
      <FieldSet>
        <FieldLegend>Silos</FieldLegend>
        <FieldDescription>
          This is a short description describing the form
        </FieldDescription>

        <FieldGroup>
          <form.AppField name="silos" mode="array">
            {(field) => {
              return (
                <>
                  {field.state.value.map((_, i) => {
                    return (
                      <Card key={`silos[${i}].siloId`}>
                        <CardContent>
                          <FieldGroup>
                            <Field orientation="horizontal">
                              <form.AppField
                                key={`silos[${i}].siloId`}
                                name={`silos[${i}].siloId`}
                              >
                                {(subField) => (
                                  <subField.TextField label="Silo ID" />
                                )}
                              </form.AppField>
                              <Field></Field>
                            </Field>

                            <Field orientation="horizontal">
                              <form.AppField
                                key={`silos[${i}].status`}
                                name={`silos[${i}].status`}
                              >
                                {(subField) => (
                                  <subField.SelectField
                                    list={siloStatusOptions}
                                    fieldLabel="Status"
                                  />
                                )}
                              </form.AppField>
                              <form.AppField key={i} name={`silos[${i}].zone`}>
                                {(subField) => (
                                  <subField.SelectField
                                    list={siloPlatformLocationOptions}
                                    fieldLabel="Zone"
                                  />
                                )}
                              </form.AppField>
                            </Field>

                            <Field orientation="horizontal">
                              <Field>
                                <div className="max-w-32">
                                  <form.AppField
                                    key={`silos[${i}].capacity`}
                                    name={`silos[${i}].capacity`}
                                  >
                                    {(subField) => (
                                      <subField.NumberSelectField
                                        label="Capacity"
                                        max={12}
                                        min={0}
                                      />
                                    )}
                                  </form.AppField>
                                </div>
                              </Field>
                              <Field>
                                <div className="max-w-32">
                                  <form.AppField
                                    key={`silos[${i}].currentInventory`}
                                    name={`silos[${i}].currentInventory`}
                                  >
                                    {(subField) => (
                                      <subField.NumberSelectField
                                        label="Current inventory"
                                        max={12}
                                        min={0}
                                      />
                                    )}
                                  </form.AppField>
                                </div>
                              </Field>
                            </Field>

                            <FieldSeparator />
                          </FieldGroup>
                        </CardContent>

                        <CardFooter>
                          <Button
                            onClick={() => field.removeValue(i)}
                            size="xs"
                            type="button"
                            variant="outline"
                          >
                            <IconX />
                            Remove
                          </Button>
                        </CardFooter>
                      </Card>
                    );
                  })}

                  <Field orientation="horizontal">
                    <Button
                      variant="outline"
                      onClick={() =>
                        field.pushValue({
                          siloId: "",
                          status: "STANDBY",
                          capacity: 6,
                          currentInventory: 6,
                          zone: "CENTER",
                        })
                      }
                      type="button"
                    >
                      <IconPlus />
                      Add Silo
                    </Button>
                  </Field>
                </>
              );
            }}
          </form.AppField>
        </FieldGroup>
      </FieldSet>
    );
  },
});
